(function () {
  'use strict';

  var mo = null;
  var debounceTimer = null;
  var busy = false;
  var loadingFallbackTimer = null;
  var repoDistRetry = null;


  function hideLoadingOverlay(force) {
    var container = document.getElementById('scasl-app-container');
    var locatorBlock = document.getElementById('locator-app-block');

    var hasVisibleContent = false;
    if (container) {
      hasVisibleContent = !!(
        container.querySelector('form#bh-sl-user-location') ||
        container.querySelector('.bh-sl-loc-list') ||
        container.querySelector('#bh-sl-map')
      );
    }

    if (!force && !hasVisibleContent) return;

    /* Mark ready — this is what the CSS keyed on */
    if (locatorBlock) {
      locatorBlock.classList.add('scasl-app-ready');
    }

    /* Also hide the overlay element if the app created one */
    var spinner = document.getElementById('scasl-loading-spinner');
    var overlay = spinner || (locatorBlock ? locatorBlock.querySelector('.scasl-loading-overlay') : null);
    if (overlay) {
      window.requestAnimationFrame(function () {
        overlay.classList.remove('show');
        overlay.style.setProperty('display', 'none', 'important');
        overlay.setAttribute('aria-hidden', 'true');
      });
    }
  }

  function scheduleLoadingFallback() {
    clearTimeout(loadingFallbackTimer);
    loadingFallbackTimer = setTimeout(function () {
      hideLoadingOverlay(true);
    }, 500);
  }

  function init() {
    var container = document.getElementById('scasl-app-container');
    if (!container) return;

    /* Bind events immediately — no DOM queries, no blocking */
    injectResultsDropdown(container);
    bindResultsChange(container);
    bindUnitChange(container);
    bindAddressReset(container);
    bindViewMapButton(container);

    /* Reveal app as early as possible */
    hideLoadingOverlay(false);

    /* Defer all DOM enhancements to next paint so reveal is instant */
    window.requestAnimationFrame(function () {
      applyResultsLimit();
      updateResultsBadge();
      updateDistanceLabels();
      repositionDistances();
      moveDirectionsIntoInfoLocation(container);
      ensureDirectionsLink(container);
      dedupePermissionErrors(container);
      removeEmptyDirectionShareBlocks(container);
      normalizeNoResultsState(container);
      ensureFirstCardFocused(container);
      setupHoursPanel(container);
      setupMobileLayout();
      ensureOriginalMapView(container);
    });
  }

  /* 7. Mobile layout — hide tabs, force column view with both list + map visible */
  function setupMobileLayout() {
     if (!window.matchMedia("(max-width: 750px)").matches) return;
    var container = document.getElementById('scasl-app-container');
    if (!container) return;

    /* Hide tabs */
    var tabs = container.querySelector('ul#scasl-tabs');
    if (tabs) tabs.style.display = 'none';

    /* Remove any inline display:none the app sets on the store list */
    var locList = container.querySelector('.bh-sl-loc-list');
    if (locList && locList.style.display === 'none') {
      locList.style.removeProperty('display');
    }

    /* Remove any inline display:none on the map / right-col */
    var rightCol = document.getElementById('scasl-right-col');
    if (rightCol && rightCol.style.display === 'none') {
      rightCol.style.removeProperty('display');
    }
    var mapDiv = document.getElementById('bh-sl-map');
    if (mapDiv && mapDiv.style.display === 'none') {
      mapDiv.style.removeProperty('display');
    }
  }

  function ensureOriginalMapView(container) {
    if (!container) return;
    /* Run only once — writing styles to every gm-style element on each observer
       fire triggers Google Maps' own internal observer, creating a feedback loop
       that causes continuous blinking (especially visible on low-end Android). */
    if (container.dataset.mapViewFixed) return;
    var mapRoot = container.querySelector('#bh-sl-map');
    if (!mapRoot) return;

    mapRoot.style.removeProperty('filter');
    mapRoot.style.removeProperty('opacity');

    mapRoot.querySelectorAll('.gm-style, .gm-style img, .gm-style canvas, .gm-style div').forEach(function (node) {
      node.style.setProperty('filter', 'none', 'important');
      node.style.setProperty('opacity', '1', 'important');
      node.style.setProperty('mix-blend-mode', 'normal', 'important');
      node.style.removeProperty('background');
    });
    container.dataset.mapViewFixed = '1';
  }

  function ensureFirstCardFocused(container) {
    if (!container) return;

    var cards = container.querySelectorAll('li#scasl-list-container');
    if (!cards.length) return;

    var focusedCard = container.querySelector('li#scasl-list-container.store-list-focus');

    /* If no card is focused yet, default to the first one */
    if (!focusedCard) {
      focusedCard = cards[0];
      focusedCard.classList.add('store-list-focus');
    }

    /* Always force yellow on the focused card — overrides app's inline background */
    focusedCard.style.setProperty('background', '#ffe512', 'important');

    /* Clear inline background from every OTHER card so only one is highlighted */
    cards.forEach(function (card) {
      if (card !== focusedCard) {
        card.style.removeProperty('background');
      }
    });
  }

  function moveDirectionsIntoInfoLocation(container) {
    if (!container) return;
    container.querySelectorAll('li#scasl-list-container').forEach(function (card) {
      var infoLocation = card.querySelector('.scasl-info-location');
      var directionField = card.querySelector('#scasl-direction.scasl-field, .scasl-field#scasl-direction');
      if (!infoLocation || !directionField) return;
      if (infoLocation.contains(directionField)) return;
      infoLocation.appendChild(directionField);
    });
  }

  function dedupePermissionErrors(container) {
    if (!container) return;
    var errors = container.querySelectorAll('span.permission-error');
    var messageHost = container.querySelector('#scasl-permission-error-host');

    /* Hide error when address field already has content (geo-filled or user-typed).
       SCASL sometimes leaves span.permission-error in the DOM even after successfully
       auto-filling the address — suppress it so it matches expected dynamic behaviour. */
    var addressInput = container.querySelector('#bh-sl-address');
    var hasAddress = addressInput && (addressInput.value || '').trim().length > 0;

    if (!errors.length || hasAddress) {
      if (messageHost) messageHost.style.display = 'none';
      errors.forEach(function (e) { e.style.display = 'none'; });
      return;
    }

    var locationForm = container.querySelector('form#bh-sl-user-location');
    if (!messageHost && locationForm && locationForm.parentNode) {
      messageHost = document.createElement('div');
      messageHost.id = 'scasl-permission-error-host';
      locationForm.parentNode.insertBefore(messageHost, locationForm.nextSibling);
    }

    var firstVisible = null;
    errors.forEach(function (error) {
      var text = (error.textContent || '').trim();
      if (!text) {
        error.style.display = 'none';
        return;
      }

      if (!firstVisible) {
        firstVisible = error;
        error.style.display = 'block';
        if (messageHost && error.parentNode !== messageHost) {
          messageHost.appendChild(error);
        }
        return;
      }

      error.style.display = 'none';
    });

    if (messageHost) {
      messageHost.style.display = firstVisible ? 'block' : 'none';
    }
  }

  function removeEmptyDirectionShareBlocks(container) {
    if (!container) return;
    container.querySelectorAll('.list-content.direction-share-link').forEach(function (block) {
      if (!block.children.length && !(block.textContent || '').trim()) {
        block.remove();
      }
    });
  }

  function normalizeNoResultsState(container) {
    if (!container) return;

    var noResultsTitle = container.querySelector('.bh-sl-noresults-title');
    var noResultsDescs = Array.from(container.querySelectorAll('.bh-sl-noresults-desc'));
    var noResultsCard = container.querySelector('.bh-sl-loc-list ul li');
    var actualCards = container.querySelectorAll('li#scasl-list-container');

    if (!noResultsTitle && !noResultsDescs.length) return;

    if (actualCards.length > 0) {
      if (noResultsTitle) noResultsTitle.style.display = 'none';
      noResultsDescs.forEach(function (desc) {
        desc.style.display = 'none';
      });
      if (noResultsCard) {
        noResultsCard.classList.remove('scasl-no-results-item');
      }
      return;
    }

    if (noResultsCard) {
      noResultsCard.classList.add('scasl-no-results-item');
      noResultsCard.style.setProperty('opacity', '1', 'important');
      noResultsCard.style.setProperty('visibility', 'visible', 'important');
    }

    if (!noResultsCard) return;

    var titleHost = noResultsTitle;
    if (!titleHost) {
      titleHost = document.createElement('div');
      titleHost.className = 'bh-sl-noresults-title';
      noResultsCard.insertBefore(titleHost, noResultsCard.firstChild);
    }
    titleHost.textContent = 'No results';
    titleHost.style.display = 'block';

    var primaryDescText = '';
    noResultsDescs.forEach(function (desc) {
      var text = (desc.textContent || '').replace(/\s+/g, ' ').trim();
      if (!primaryDescText && text) {
        primaryDescText = text;
      }
      if (desc.parentNode) {
        desc.parentNode.removeChild(desc);
      }
    });

    if (!primaryDescText) {
      primaryDescText = 'No locations were found with the given tags. Please modify your selections or input.';
    }

    var descHost = noResultsCard.querySelector('.bh-sl-noresults-desc');
    if (!descHost) {
      descHost = document.createElement('div');
      descHost.className = 'bh-sl-noresults-desc';
      noResultsCard.appendChild(descHost);
    }
    descHost.textContent = primaryDescText;
    descHost.style.display = 'block';

    Array.from(noResultsCard.children).forEach(function (child) {
      if (child === titleHost || child === descHost) return;
      if (child.tagName === 'BR') {
        child.remove();
      }
    });
  }

  function removeMetaInfoRows(container) {
    if (!container) return;
    container.querySelectorAll('li#scasl-list-container').forEach(function (card) {
      var shareBlock = card.querySelector('.list-content.direction-share-link');
      if (!shareBlock) return;
      var metaRow = shareBlock.nextElementSibling;
      if (!metaRow) return;
      if (metaRow.tagName !== 'DIV') return;
      if (metaRow.querySelector('.scasl-operating-hour')) return;
      if (metaRow.querySelector('hr')) return;
      metaRow.remove();
    });
  }

  /* 6. Operating Hours panel — wrapped with #bh-sl-map in a right-column div */
  function setupHoursPanel(container) {
    var mapDiv = container.querySelector('#bh-sl-map');
    if (!mapDiv) return;

    /* Wrap #bh-sl-map inside #scasl-right-col (takes map's place in the layout) */
    var wrapper = document.getElementById('scasl-right-col');
    if (!wrapper || !wrapper.contains(mapDiv)) {
      if (wrapper) wrapper.remove();
      wrapper = document.createElement('div');
      wrapper.id = 'scasl-right-col';
      mapDiv.parentNode.insertBefore(wrapper, mapDiv);
      wrapper.appendChild(mapDiv);
    }

    /* Ensure hours panel lives inside the same wrapper, after map */
    var panel = document.getElementById('scasl-hours-panel');
    if (!panel) {
      panel = document.createElement('div');
      panel.id = 'scasl-hours-panel';
      wrapper.appendChild(panel);
    } else if (panel.parentNode !== wrapper) {
      wrapper.appendChild(panel);
    }

    /* Active card */
    var activeCard = container.querySelector('li#scasl-list-container.store-list-focus');
    if (!activeCard) {
      panel.style.display = 'none';
      panel.innerHTML = '';
      return;
    }

    var hoursField = activeCard.querySelector('.scasl-operating-hour');
    if (!hoursField) {
      panel.style.display = 'none';
      panel.innerHTML = '';
      return;
    }

    /* Read hours data directly from the app's table rows (works even when hidden) */
    var rows = hoursField.querySelectorAll('tr');
    var hoursData = [];
    rows.forEach(function (row) {
      var cells = row.querySelectorAll('td');
      if (cells.length >= 2) {
        var day = cells[0].textContent.trim();
        var time = cells[1].textContent.trim();
        if (day) hoursData.push({ day: day, time: time });
      }
    });

    if (!hoursData.length) {
      panel.style.display = 'none';
      panel.innerHTML = '';
      return;
    }

    /* Build a fresh clean table — no app CSS classes, no toggle elements */
    var table = document.createElement('table');
    table.style.cssText = 'width:100%;border-collapse:collapse;';

    hoursData.forEach(function (item) {
      var tr = document.createElement('tr');
      var tdDay = document.createElement('td');
      var tdTime = document.createElement('td');
      tdDay.className = 'scasl-ph-day';
      tdTime.className = 'scasl-ph-time';
      tdDay.textContent = item.day;
      tdTime.textContent = item.time;
      tr.appendChild(tdDay);
      tr.appendChild(tdTime);
      table.appendChild(tr);
    });

    panel.innerHTML = '';
    panel.appendChild(table);
    panel.style.display = 'block';
  }

  /* 1. Inject Results dropdown before the Search button in the form */
  function injectResultsDropdown(container) {
    if (document.getElementById('scasl-results-per-page')) return;

    /* Find the search button wrapper – try multiple selectors */
    var searchWrap = container.querySelector('.scasl-search-btn')
      || container.querySelector('#bh-sl-submit');
    if (!searchWrap) return;

    var wrap = document.createElement('div');
    wrap.id = 'scasl-results-control';
    wrap.className = 'form-input';

    var lbl = document.createElement('label');
    lbl.setAttribute('for', 'scasl-results-per-page');
    lbl.textContent = 'Results';

    var sel = document.createElement('select');
    sel.id = 'scasl-results-per-page';
    [1, 2, 5, 10, 15, 20, 25, 30].forEach(function (n) {
      var opt = document.createElement('option');
      opt.value = n;
      opt.textContent = n;
      if (n === 10) opt.selected = true;
      sel.appendChild(opt);
    });

    wrap.appendChild(lbl);
    wrap.appendChild(sel);
    searchWrap.parentNode.insertBefore(wrap, searchWrap);
  }

  /* 5. Move distance value into the store title row */
  function extractDistText(el) {
    if (!el) return '';
    /* Try inner div first, fall back to the element itself */
    var inner = el.querySelector('div') || el;
    var raw = (inner.textContent || '').trim();
    if (!raw) {
      /* Try stripping a label span */
      var lbl = el.querySelector('span');
      raw = el.textContent.replace(lbl ? lbl.textContent : '', '').trim();
    }
    /* Strip any "Distance:" label that may prefix the value */
    raw = raw.replace(/^distance[:\s]*/i, '').trim();

    /* Normalise unit words so we can detect them consistently */
    raw = raw.replace(/kilometers?/gi, 'km').replace(/\bmiles?\b/gi, 'mi').trim();
    if (!raw) return '';

    /* Always display in km — convert mi → km when necessary */
    var miMatch = raw.match(/^([\d.]+)\s*mi$/i);
    if (miMatch) {
      var km = parseFloat(miMatch[1]) * 1.60934;
      /* One decimal place, strip trailing ".0" */
      var kmStr = km.toFixed(1).replace(/\.0$/, '');
      return kmStr + ' km';
    }

    /* Already km — return as-is */
    return raw;
  }

  function repositionDistances() {
    var container = document.getElementById('scasl-app-container');
    if (!container) return;
    var needsRetry = false;
    container.querySelectorAll('li#scasl-list-container').forEach(function (li) {
      /* Use broad selector — some ProMap versions omit the scasl-field class */
      var distField = li.querySelector('#scasl-distance');

      var existingRow = li.querySelector('.scasl-title-dist-row');
      if (existingRow) {
        /* Row already built — sync badge with current distance value */
        var existingBadge = existingRow.querySelector('.scasl-dist-badge');
        var dt = extractDistText(distField);
        if (dt) {
          if (!existingBadge) {
            var nb = document.createElement('span');
            nb.className = 'scasl-dist-badge';
            nb.textContent = dt;
            existingRow.appendChild(nb);
          } else if (existingBadge.textContent !== dt) {
            existingBadge.textContent = dt;
          }
        } else {
          /* Distance not ready yet — retry later */
          if (existingBadge) existingBadge.parentNode.removeChild(existingBadge);
          needsRetry = true;
        }
        return;
      }

      var titleEl = li.querySelector('#scasl-title.scasl-field, .scasl-title, #scasl-title');
      if (!titleEl) return;

      /* Build a flex row: [title] [distance badge?] */
      var row = document.createElement('div');
      row.className = 'scasl-title-dist-row';
      titleEl.parentNode.insertBefore(row, titleEl);
      row.appendChild(titleEl);

      /* Always place pin icon outside .scasl-info-location, inside .image-title-group */
      var infoLoc = li.querySelector('.scasl-info-location');
      var imgGroup = li.querySelector('.image-title-group');
      if (imgGroup && infoLoc && !imgGroup.querySelector('.scasl-pin-icon')) {
        var pin = document.createElement('img');
        pin.className = 'scasl-pin-icon';
        pin.setAttribute('src', 'https://cdn.shopify.com/s/files/1/0755/6340/1356/files/pin.svg?v=1773730230');
        pin.setAttribute('alt', '');
        pin.setAttribute('aria-hidden', 'true');
        imgGroup.insertBefore(pin, infoLoc);
      }

      var distText = extractDistText(distField);
      if (distText) {
        var badge = document.createElement('span');
        badge.className = 'scasl-dist-badge';
        badge.textContent = distText;
        row.appendChild(badge);
      } else {
        /* Distance not ready yet — flag for retry */
        needsRetry = true;
      }

      /* Mark card so CSS can show Directions and hide the duplicate Distance field */
      li.classList.add('scasl-dist-moved');
    });

    /* App may populate distance asynchronously. Retry quickly: 100ms then 300ms. */
    clearTimeout(repoDistRetry);
    if (needsRetry) {
      var attempt = repositionDistances._attempt || 0;
      var delays = [100, 300];
      if (attempt < delays.length) {
        repositionDistances._attempt = attempt + 1;
        repoDistRetry = setTimeout(repositionDistances, delays[attempt]);
      } else {
        repositionDistances._attempt = 0;
      }
    } else {
      repositionDistances._attempt = 0;
    }
  }

  /* 5b. Inject a Google Maps Directions link for cards that SCASL did not provide one */
  function ensureDirectionsLink(container) {
    if (!container) return;
    container.querySelectorAll('li#scasl-list-container').forEach(function (li) {
      var infoLoc = li.querySelector('.scasl-info-location');
      if (!infoLoc) return;
      if (infoLoc.querySelector('#scasl-direction')) return; /* already present */

      var parts = [];
      var addrEl  = li.querySelector('#scasl-address');
      var addr2El = li.querySelector('#scasl-address2');
      var cityEl  = li.querySelector('#scasl-city');
      var stateEl = li.querySelector('#scasl-state');
      var countryEl = li.querySelector('#scasl-country');
      if (addrEl)    parts.push((addrEl.textContent    || '').trim());
      if (addr2El)   parts.push((addr2El.textContent   || '').trim());
      if (cityEl)    parts.push((cityEl.textContent    || '').trim());
      if (stateEl)   parts.push((stateEl.textContent   || '').trim());
      if (countryEl) parts.push((countryEl.textContent || '').trim());
      var fullAddr = parts.filter(Boolean).join(', ');
      if (!fullAddr) return;

      var dirDiv = document.createElement('div');
      dirDiv.id = 'scasl-direction';
      dirDiv.className = 'scasl-field';
      var link = document.createElement('a');
      link.href = 'https://maps.google.com/maps?q=' + encodeURIComponent(fullAddr);
      link.target = '_blank';
      link.title = 'Directions to ' + fullAddr;
      link.setAttribute('aria-label', 'Directions to ' + fullAddr);
      link.textContent = 'Directions';
      dirDiv.appendChild(link);
      infoLoc.appendChild(dirDiv);
    });
  }

  /* 2a. Listen for Results dropdown change */
  function bindResultsChange(container) {
    if (container.dataset.resultsReady) return;
    container.addEventListener('change', function (e) {
      if (e.target && e.target.id === 'scasl-results-per-page') {
        applyResultsLimit();
        updateResultsBadge();
      }
    });
    container.dataset.resultsReady = '1';
  }

  /* 2b. Listen for unit (km/miles) dropdown change */
  function bindUnitChange(container) {
    if (container.dataset.unitReady) return;
    container.addEventListener('change', function (e) {
      if (e.target && e.target.id === 'scasl-lengthUnit') {
        updateDistanceLabels();
      }
    });
    container.dataset.unitReady = '1';
  }

  function restoreInitialList() {
    var container = document.getElementById('scasl-app-container');
    if (!container) return;

    /* Clear the address input (silently — isTrusted=false events are ignored by bindAddressReset) */
    var addressInput = container.querySelector('#bh-sl-address');
    if (addressInput) {
      addressInput.value = '';
    }

    /* Trigger the app's own search with empty address.
       ProMap RP returns the full default store list when no address is given,
       exactly matching the initial page-load state — no page reload needed. */
    var submitBtn = container.querySelector('#bh-sl-submit')
      || container.querySelector('button[type="submit"]')
      || container.querySelector('.scasl-search-btn');
    if (submitBtn) {
      submitBtn.click();
      return;
    }

    /* Last resort fallback */
    var form = container.querySelector('form#bh-sl-user-location');
    if (form) {
      if (typeof form.requestSubmit === 'function') form.requestSubmit();
      else form.submit();
    }
  }

  function bindViewMapButton(container) {
    if (container.dataset.viewMapReady) return;
    container.addEventListener('click', function (e) {
    if (!window.matchMedia("(max-width: 750px)").matches) return;
      var target = e.target;
      var btn = (target.classList && target.classList.contains('scasl-view-map-btn'))
        ? target
        : (target.closest ? target.closest('.scasl-view-map-btn') : null);
      if (!btn) return;
      var mapEl = document.getElementById('scasl-right-col') || document.getElementById('bh-sl-map');
      if (mapEl) mapEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    container.dataset.viewMapReady = '1';
  }

  function bindAddressReset(container) {
    if (container.dataset.addressResetReady) return;

    container.addEventListener('input', function (e) {
      if (!e.target || e.target.id !== 'bh-sl-address') return;
      if (e.isTrusted === false) return;

      var value = (e.target.value || '').trim();
      if (value) {
        container.dataset.hadManualAddress = '1';
        container.dataset.addressResetPending = '0';
        return;
      }

      if (container.dataset.hadManualAddress !== '1') return;
      if (container.dataset.addressResetPending === '1') return;

      container.dataset.addressResetPending = '1';

      window.setTimeout(function () {
        var currentInput = container.querySelector('#bh-sl-address');
        if (currentInput && (currentInput.value || '').trim()) {
          container.dataset.addressResetPending = '0';
          return;
        }
        container.dataset.hadManualAddress = '0';
        container.dataset.addressResetPending = '0';
        restoreInitialList();
      }, 150);
    });

    container.dataset.addressResetReady = '1';
  }

  /* 2c. Update distance option text to show "10 km" / "10 mi" etc. */
  function updateDistanceLabels() {
    var distSel = document.getElementById('scasl-radius-container')
      || document.querySelector('#scasl-app-container select[name="bh-sl-max-distance"]');
    if (!distSel) return;

    var unitSel = document.getElementById('scasl-lengthUnit');
    var unitVal = unitSel ? unitSel.value : 'km';
    var unitLabel = (unitVal === 'mi' || unitVal === 'miles') ? 'mi' : 'km';

    Array.from(distSel.options).forEach(function (opt) {
      /* Detect "No Limit" option — fresh (value=0), already patched, or re-rendered by ProMap */
      var isNoLimit = opt.value === '0'
        || opt.dataset.noLimit === '1'
        || (opt.textContent || '').toLowerCase().indexOf('no limit') !== -1;

      if (isNoLimit) {
        if (opt.value !== '99999') opt.value = '99999';
        if (!opt.dataset.noLimit) opt.dataset.noLimit = '1';
        /* Ensure display text always reads "No Limit" */
        if ((opt.textContent || '').toLowerCase().indexOf('no limit') === -1) {
          opt.textContent = 'No Limit';
        }
        return;
      }

      var num = parseInt(opt.value, 10);
      if (!num || num <= 0) return; /* skip non-numeric options */
      if (!opt.dataset.origNum) {
        opt.dataset.origNum = opt.value;
      }
      /* Only write if text actually differs — prevents the native Android
         select picker from redrawing/blinking on every observer fire */
      var wanted = opt.dataset.origNum + ' ' + unitLabel;
      if (opt.textContent !== wanted) opt.textContent = wanted;
    });
  }

  /* 3. Show/hide store cards based on selected count via injected CSS */
  function applyResultsLimit() {
    var sel = document.getElementById('scasl-results-per-page');
    var limit = sel ? parseInt(sel.value, 10) : 10;

    var styleTag = document.getElementById('scasl-results-limit-style');
    if (!styleTag) {
      styleTag = document.createElement('style');
      styleTag.id = 'scasl-results-limit-style';
      document.head.appendChild(styleTag);
    }
    /* Always hide items beyond the limit; never force display:block which would
       override SCASL's own radius-based filtering on items within the limit. */
    styleTag.textContent = '#scasl-app-container .bh-sl-loc-list ul li:nth-child(n+' + (limit + 1) + ') { display: none !important; }';
  }

  function getVisibleListedCards(container) {
    if (!container) return [];
    return Array.from(container.querySelectorAll('li#scasl-list-container')).filter(function (card) {
      if (!card.isConnected) return false;
      if (!card.offsetParent && card !== document.body) return false;
      var styles = window.getComputedStyle(card);
      return styles.display !== 'none' && styles.visibility !== 'hidden';
    });
  }

  /* 4. Update "X - Y from Z stores found" text */
  function updateResultsBadge() {
    var container = document.getElementById('scasl-app-container');
    if (!container) return;
    var all = container.querySelectorAll('li#scasl-list-container');
    var total = all.length;
    var addressInput = container.querySelector('#bh-sl-address');
    var hasAddressValue = !!(addressInput && (addressInput.value || '').trim());

    var sel = document.getElementById('scasl-results-per-page');
    var limit = sel ? parseInt(sel.value, 10) : 10;
    var listedCards = getVisibleListedCards(container);
    var visible = Math.min(limit, listedCards.length);

    var badge = document.getElementById('scasl-results-count-badge');
    if (!badge) {
      badge = document.createElement('div');
      badge.id = 'scasl-results-count-badge';
      var locList = container.querySelector('.bh-sl-loc-list');
      if (locList) locList.parentNode.insertBefore(badge, locList);
    }
    badge.style.display = '';

    if (!hasAddressValue && container.dataset.addressResetPending === '1') {
      var pendingText = total > 0 ? '1 - ' + Math.min(limit, total) + ' from ' + total + ' stores found' : '';
      if (badge.textContent !== pendingText) badge.textContent = pendingText;
      return;
    }

    if (container.querySelector('.bh-sl-noresults-title')) {
      badge.style.display = 'none';
      return;
    }

    if (listedCards.length === 0) {
      badge.style.display = 'none';
      return;
    }

    var badgeText = '1 - ' + visible + ' from ' + total + ' stores found';
    if (badge.textContent !== badgeText) badge.textContent = badgeText;
  }

  /* MutationObserver: re-run when app renders results */
  function observe() {
    var target = document.getElementById('scasl-app-container') || document.body;
    mo = new MutationObserver(function () {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () {
        if (busy) return;
        busy = true;
        if (mo) mo.disconnect();
        try {
          var container = document.getElementById('scasl-app-container');
          if (container) {
            injectResultsDropdown(container);
            bindResultsChange(container);
            bindUnitChange(container);
            bindAddressReset(container);
            bindViewMapButton(container);
            applyResultsLimit();
            updateResultsBadge();
            updateDistanceLabels();
            repositionDistances();
            moveDirectionsIntoInfoLocation(container);
            ensureDirectionsLink(container);
            dedupePermissionErrors(container);
            removeEmptyDirectionShareBlocks(container);
            normalizeNoResultsState(container);
            ensureFirstCardFocused(container);
            setupHoursPanel(container);
            setupMobileLayout();
            hideLoadingOverlay(false);
            window.requestAnimationFrame(function () { ensureOriginalMapView(container); });

            /* Delayed re-run: ProMap may populate distance text AFTER the
               initial render.  A second pass picks up late-arriving values. */
            setTimeout(function () {
              repositionDistances();
              updateResultsBadge();
            }, 100);
          }
        } finally {
          busy = false;
          observe();
        }
      }, 60);
    });
    /* childList+subtree only — no characterData, which would fire on every text
       change and create a feedback loop that blinks the native select picker.
       Distance badges are handled by the 100ms/300ms retry timers instead. */
    mo.observe(target, { childList: true, subtree: true });
  }

  /* Boot: wait for app container if not yet in DOM */
  function waitForContainer() {
    scheduleLoadingFallback();
    if (document.getElementById('scasl-app-container')) {
      init();
      observe();
      return;
    }
    var bodyObs = new MutationObserver(function () {
      if (document.getElementById('scasl-app-container')) {
        bodyObs.disconnect();
        init();
        observe();
      }
    });
    bodyObs.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForContainer);
  } else {
    waitForContainer();
  }
  window.addEventListener("resize", function () {
  var container = document.getElementById("scasl-app-container");
  if (!container) return;

  setupMobileLayout();
  applyResultsLimit();
  updateResultsBadge();
  repositionDistances();
});
})();

